import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import customerQueryKeys from './customerQueryKeys'
import { getCustomers } from '../service/customerService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Company } from '../../../types/company/Company'
import { Customer } from '../../../types/customer/customer'

export const useCustomers = <TData = Customer[]>(
  companyId?: Company['id'],
  select?: (data: Customer[]) => TData,
  enabled = true
) =>
  useQuery(
    queryOptions({
      queryKey: customerQueryKeys.list({ companyId }),
      queryFn: getCustomers,
      enabled: !!companyId && enabled,
      gcTime: 15 * 60 * 1000,
      select: data => {
        const sorted = [...data].sort((a, b) => a.name.localeCompare(b.name))
        return select ? select(sorted) : (sorted as TData)
      }
    })
  )

export const useCtxCustomers = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useCustomers(companyId)
}
